export default __webpack_public_path__ + "static/media/916.ab078d67.gif";